<button [type]="type" (click)="onClick()" mat-flat-button [color]="color" [disabled]="disabled">
    <span *ngIf="iconClass" class="fal fa-fw fa-material" [ngClass]="iconClass">&nbsp;</span>{{titleTranslateKey |
    translate : titleArgument}}
    <ng-content></ng-content>
</button>